var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeAvatar8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0008 56.8744C20.9024 56.8744 9.47266 45.4447 9.47266 31.3463C9.47266 30.0908 10.4901 29.0719 11.7471 29.0719H58.256C59.5115 29.0719 60.5304 30.0893 60.5304 31.3463C60.5304 45.4447 49.1007 56.8744 35.0023 56.8744H35.0008Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0921 48.3334L27.8596 48.3334C26.9878 48.3334 25.7433 49.2734 25.8387 50.3211V53.3334C28.4525 54.0654 31.2502 55 34.1668 55V49.9718C34.1668 49.2538 32.9623 48.3334 32.0921 48.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 50.3223C45.0001 49.2747 43.8472 48.3334 42.9764 48.3334H38.7412C37.8689 48.3334 36.6667 49.2551 36.6667 49.9731V55C39.5827 55 42.3831 54.0654 45.0001 53.3334V50.3223Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4168 40.8334H40.0807C37.9469 40.8334 36.6668 39.0542 36.6668 37.9762V30.8334H48.7501V37.9762C48.7501 39.0542 47.5506 40.8334 45.4168 40.8334Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7529 40.8334H25.4168C23.2831 40.8334 22.003 39.0542 22.003 37.9762V30.8334H34.0863V37.9762C34.0863 39.0542 32.8867 40.8334 30.7529 40.8334Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0009 57.7842C20.4233 57.7842 8.56299 45.9238 8.56299 31.3463C8.56299 29.5904 9.99133 28.1621 11.7472 28.1621H58.2561C60.0119 28.1621 61.4403 29.5904 61.4403 31.3463C61.4403 45.9238 49.5799 57.7842 35.0024 57.7842H35.0009ZM11.7457 30.5833C10.9936 30.5833 10.381 30.5942 10.381 31.3463C10.381 44.9216 21.4256 55.9647 34.9994 55.9647C48.5731 55.9647 59.6177 44.9201 59.6177 31.3463C59.6177 30.5942 59.0051 30.5833 58.2531 30.5833H11.7457Z",
    fill: "#307F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar8);
export default __webpack_public_path__ + "static/media/Office-Avatar-8.e22e6a4fd9815c7b2f3a6852781f1a95.svg";
export { ForwardRef as ReactComponent };